<form name="editJobPurchaseOrderForm" #editJobPurchaseOrderForm="ngForm" class="form-v2">
    <div class="modal-header padding-top-5 padding-bottom-5">
        <h4 class="modal-title" id="orderTitle">
            {{ type.value }} Order Details : {{ purchaseOrder.OrderNumberString }}
            <div class="pull-right margin-top-10 margin-right-10">
                @if (!orderTypeHidden) {
                    <select
                        legacy-css
                        id="orderType"
                        class="form-control"
                        [(ngModel)]="purchaseOrder.OrderType"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="setType()"
                        [disabled]="orderTypeDisabled">
                        <option *ngFor="let t of types" [ngValue]="t.value">{{ t.name }}</option>
                    </select>
                }
            </div>
            <span class="modal-sub-title">{{ purchaseOrder.Job.FullDescription }}</span>
        </h4>
    </div>

    <div class="modal-body" id="orderFormBody">
        <fieldset [disabled]="purchaseOrder.ID_JobPayment" class="fieldset-transparent">
            <div class="alert alert-block alert-info" *ngIf="purchaseOrder.HasInvoiceAccSyncData && !importSettings">
                <p class="text-normal"><i class="ti-cloud-up"></i> {{ orderAccountingSyncLabel }}</p>
            </div>

            <fieldset class="fieldset-transparent" [class.modal-white--disabled]="orderFormDisabled">
                <div class="row">
                    <div class="col-md-9 col-sm-8 col-xs-12">
                        <div class="form-group">
                            <label class="text-info">
                                Description <small *ngIf="purchaseOrder.Job?.InvoiceMethod !== 1">(Internal use only)</small
                                ><small *ngIf="purchaseOrder.Job?.InvoiceMethod === 1">(Prints on your invoice)</small>
                            </label>
                            <input
                                legacy-css
                                type="text"
                                class="form-control"
                                placeholder="Description"
                                id="orderDescription"
                                name="orderDescription"
                                [(ngModel)]="purchaseOrder.Description"
                                appAutoFocus
                                maxlength="100" />
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-4 col-xs-12">
                        <div class="form-group">
                            <label class="text-info"> Status </label>
                            <ng-select
                                class="light order-status-select"
                                name="status"
                                id="orderStatusDropdown"
                                [items]="orderStatuses"
                                #status="ngModel"
                                bindValue="name"
                                [searchable]="false"
                                (change)="orderStatusChanged()"
                                [clearable]="false"
                                [(ngModel)]="purchaseOrder.OrderStatus">
                                <ng-template ng-label-tmp let-item="item">
                                    <div>
                                        <span
                                            class="label order-status-label"
                                            [ngClass]="{
                                                'label-inverse': purchaseOrder.OrderStatus === 'Unsent',
                                                'label-warning': purchaseOrder.OrderStatus === 'Sent',
                                                'label-info': purchaseOrder.OrderStatus === 'PartReceived',
                                                'label-success':
                                                    purchaseOrder.OrderStatus === 'Received' || purchaseOrder.OrderStatus === 'Completed',
                                                'label-danger': purchaseOrder.OrderStatus === 'Cancelled',
                                            }"
                                            >{{ purchaseOrder.OrderStatus }}</span
                                        >
                                    </div>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    {{ item.name }}
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6 col-xs-12">
                        <div class="form-group">
                            <h4 class="text-info">
                                <span class="mandatory-field">{{ purchaseOrder.OrderType === 'work' ? 'Assigned To' : 'Contact' }}</span>
                            </h4>
                            <ngx-select
                                [items]="contacts"
                                [disabled]="
                                    (!importSettings && purchaseOrder.OrderStatus === 'Received') ||
                                    purchaseOrder.OrderStatus === 'Cancelled'
                                "
                                id="supplier"
                                name="supplier"
                                optionValueField="ID_Contact"
                                optionTextField="Description"
                                [autoClearSearch]="true"
                                required
                                [allowClear]="false"
                                [(ngModel)]="purchaseOrder.ID_Contact"
                                (ngModelChange)="onSupplierChanged($event)">
                                <ng-template ngx-select-option ngx-select-option-selected let-option let-text="text">
                                    {{ option.data.Description }}
                                    <app-bx-contact-card-status
                                        [status]="option.data.CardStatus"
                                        [cardExpiryNextFriendly]="option.data.CardExpiryNextFriendly"></app-bx-contact-card-status>
                                </ng-template>
                                <ng-template ngx-select-option-not-found let-input>
                                    <a class="text-normal padding-0" (click)="addNewContact(input)">Add '{{ input }}' as a new contact</a>
                                </ng-template>
                            </ngx-select>
                        </div>
                    </div>
                    <div class="col-md-6 col-xs-12">
                        <div class="form-group">
                            <h4 class="text-info">
                                {{ purchaseOrder.OrderType === 'work' ? 'Work Location' : 'Deliver To' }}
                                <div
                                    class="checkbox text-normal pull-right margin-top-0 margin-bottom-0"
                                    tooltip="No delivery required, you will pick up from supplier">
                                    <input
                                        legacy-css
                                        type="checkbox"
                                        id="isPickup"
                                        name="isPickup"
                                        placeholder="Pick up"
                                        [(ngModel)]="purchaseOrder.IsPickup"
                                        [disabled]="purchaseOrder.OrderStatus !== 'Unsent'" />
                                    <label for="isPickup" class="text-left"> Pick up </label>
                                </div>
                            </h4>
                            <app-bx-address-input
                                [inputLegacyCss]="true"
                                inputClass="form-control form-control-v2"
                                id="deliveryAddress"
                                name="deliveryAddress"
                                [inputDisabled]="purchaseOrder.OrderStatus !== 'Unsent'"
                                #address1="ngModel"
                                inputMaxLength="200"
                                [(ngModel)]="purchaseOrder.DeliveryAddress1"
                                (onAddressSelected)="handleAddressChange($event)" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6 col-xs-12">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label class="text-info"> Attention </label>
                                    <input
                                        legacy-css
                                        type="text"
                                        class="form-control"
                                        id="attention"
                                        name="attention"
                                        [(ngModel)]="purchaseOrder.SupplierAttention"
                                        placeholder="Attention"
                                        [typeahead]="contactPeople"
                                        typeaheadOptionField="FullName"
                                        [typeaheadMinLength]="0"
                                        maxlength="50" />
                                    <span
                                        class="validation-invalid"
                                        *ngIf="purchaseOrder.SupplierAttention && purchaseOrder.SupplierAttention.length > 50"
                                        >Maximum of 50 characters</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xs-12">
                        <div class="form-group">
                            <label class="text-info" translate="general.address.city"></label>
                            <input
                                legacy-css
                                type="text"
                                class="form-control"
                                id="deliveryCityTown"
                                name="deliveryCityTown"
                                [attr.placeholder]="'general.address.city' | translate"
                                [(ngModel)]="purchaseOrder.DeliveryCityTown"
                                maxlength="50"
                                [disabled]="purchaseOrder.OrderStatus !== 'Unsent'" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6 col-xs-12">
                        <div class="row">
                            <div
                                [ngClass]="{
                                    'col-xs-6': purchaseOrder.OrderStatus === 'Received' || purchaseOrder.OrderStatus === 'Completed',
                                    'col-xs-12': purchaseOrder.OrderStatus !== 'Received' && purchaseOrder.OrderStatus !== 'Completed',
                                }">
                                <div class="form-group">
                                    <label class="text-info"> Date required </label>
                                    <input
                                        legacy-css
                                        id="requiredByDate"
                                        name="requiredByDate"
                                        #startDatePicker="bsDatepicker"
                                        type="text"
                                        class="form-control"
                                        [(ngModel)]="purchaseOrder.RequiredByDateLocal"
                                        bsDatepicker
                                        [bsConfig]="{
                                            adaptivePosition: true,
                                            showWeekNumbers: false,
                                            containerClass: 'theme-default',
                                            customTodayClass: 'bsdatepicker-today',
                                            dateInputFormat: dateFormat,
                                        }" />
                                </div>
                            </div>
                            <div
                                class="col-xs-6"
                                *ngIf="purchaseOrder.OrderStatus === 'Received' || purchaseOrder.OrderStatus === 'Completed'">
                                <div class="form-group">
                                    <label class="text-info">
                                        {{ purchaseOrder.OrderStatus === 'Received' ? 'Received Date' : 'Completed Date' }}
                                    </label>
                                    <input
                                        legacy-css
                                        id="receivedDate"
                                        name="receivedDate"
                                        #startDatePicker="bsDatepicker"
                                        type="text"
                                        class="form-control"
                                        [(ngModel)]="purchaseOrder.ReceivedDate"
                                        bsDatepicker
                                        [bsConfig]="{
                                            adaptivePosition: true,
                                            showWeekNumbers: false,
                                            containerClass: 'theme-default',
                                            customTodayClass: 'bsdatepicker-today',
                                            dateInputFormat: dateFormat,
                                        }" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xs-12">
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label class="text-info" translate="general.address.state"></label>
                                    <select
                                        legacy-css
                                        class="form-control"
                                        id="deliveryState"
                                        name="deliveryState"
                                        [(ngModel)]="purchaseOrder.DeliveryState"
                                        [disabled]="purchaseOrder.OrderStatus !== 'Unsent'">
                                        <option value="">Please select</option>
                                        <option *ngFor="let s of sharedData.Common.StatesInfo" [ngValue]="s.value">{{ s.value }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label class="text-info" translate="general.address.postcode"></label>
                                    <input
                                        legacy-css
                                        type="text"
                                        class="form-control"
                                        id="deliveryPostcode"
                                        name="deliveryPostcode"
                                        [attr.placeholder]="'general.address.postcode' | translate"
                                        [(ngModel)]="purchaseOrder.DeliveryPostCode"
                                        maxlength="50"
                                        [disabled]="purchaseOrder.OrderStatus !== 'Unsent'" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label class="text-info pull-left"> Instructions </label>
                            <presets-dropdown
                                presetType="purchaseorderinstructions"
                                [(content)]="purchaseOrder.Instructions"
                                [placement]="'right'"
                                class="pull-right margin-bottom-5"></presets-dropdown>
                            <textarea
                                legacy-css
                                class="form-control"
                                placeholder="Instructions"
                                id="instructions"
                                name="instructions"
                                [(ngModel)]="purchaseOrder.Instructions"
                                style="min-height: 75px"></textarea>
                        </div>
                    </div>
                </div>
            </fieldset>

            <div class="alert alert-warning" *ngIf="statusChangedToReceived && purchaseOrder.OrderType === 'work'">
                <h4 class="alert-heading"><i class="ti-alert"></i> Did you complete what you estimated?</h4>
                {{ appSettings.app.name }} needs to know what you actually completed so it can be compared with the estimate. Please update
                any quantities or dollar values before saving.
            </div>

            <div class="alert alert-warning" *ngIf="purchaseOrder.ID_JobPayment">
                <h4 class="alert-heading"><i class="ti-alert"></i> Locked Order</h4>
                This Order is locked because its attached to an invoice. Please remove from the invoice if you wish to make changes.
            </div>
            <div class="alert alert-info padding-5 margin-0" *ngIf="importSettings?.importingIntoExistingOrder">
                Items from your bill are highlighted in orange
            </div>
            <fieldset
                class="panel panel-white padding-0"
                [disabled]="purchaseOrder.OrderStatus === 'Cancelled'"
                [class.modal-white--disabled]="orderFormDisabled">
                <div class="panel-heading border-light">
                    <h4 class="panel-title">{{ itemCount }} Item<span *ngIf="itemCount !== 1">s</span></h4>
                    <ul class="panel-heading-tabs border-light">
                        <li *ngIf="editing && isAllowedToAddItem">
                            <div class="btn-group">
                                <button
                                    type="button"
                                    id="addOrderItemBtn"
                                    class="btn-bx-primary"
                                    style="min-width: 30px"
                                    (appSingleClick)="addOrderItem()"
                                    tooltip="Add item"
                                    container="body">
                                    <i class="ti-plus"></i>
                                </button>
                            </div>
                        </li>
                        <li class="hidden-xs">
                            <h4 class="panel-title margin-top-15">
                                {{ purchaseOrder.IsTaxFree ? 'Total ' : 'Total (Inc) ' }}
                                <strong id="orderTotalHeader">{{ purchaseOrder.OrderTotalIncTax | bxCurrency }}</strong>
                            </h4>
                        </li>
                    </ul>
                </div>
                <div class="panel-body" id="panelbody">
                    <div class="alert alert-warning padding-5 margin-0" *ngIf="validateCategories() && !this.importSettings">
                        Please indicate which category the highlighted items should go into. Leaving this field blank will place the items
                        in a new category
                    </div>
                    <div class="form-group">
                        <div class="table-responsive">
                            <table class="table table-white">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Description</th>
                                        <th></th>
                                        <th>Notes</th>
                                        <th class="text-left" *ngIf="purchaseOrder.Job?.CalculationMethod! >= 1">Type</th>
                                        <th class="text-right">Qty</th>
                                        <th class="text-right">Unit Cost (Ex)</th>
                                        <th class="text-center">UOM</th>
                                        <th class="text-right">Total Cost (Ex)</th>
                                        <th class="text-center" *ngIf="purchaseOrder.Job?.CalculationMethod! >= 1">{{ taxCode }}</th>
                                        <th>Actuals Category</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody class="order-items-table-body" cdkDropList (cdkDropListDropped)="dropOrderItem($event)">
                                    <ng-container
                                        *ngFor="
                                            let item of purchaseOrder.PurchaseOrderItems
                                                | simpleFilter: { IsDeleted: false }
                                                | simpleSort: 'Order';
                                            let i = index
                                        ">
                                        <ng-template #costItemInfoTooltipTemplate let-model="item" let-index="index" let-query="query">
                                            <p>{{ model.CostItem?.Details }}</p>
                                            <div *ngIf="model.CostItem?.CostBreakdown">
                                                <p>
                                                    <strong>Cost Breakdown:</strong><br />{{ model.CostItem?.getCostBreakdownAsString() }}
                                                </p>
                                            </div>
                                        </ng-template>
                                        <tr
                                            [ngClass]="item.ImportedIntoExistingOrder ? 'order-items-table-item-highlight' : ''"
                                            id="itemRow{{ item.ID_PurchaseOrderItem }}"
                                            cdkDrag
                                            cdkDragBoundary=".order-items-table-body">
                                            <td class="width-40">
                                                <div class="grip-container">
                                                    <span class="grip" cdkDragHandle></span>
                                                </div>
                                            </td>
                                            <td class="condensed-col col-xs-5">
                                                <span *ngIf="!editing">{{ item.Description }}</span>
                                                <span
                                                    *ngIf="!editing && item.CostItem?.HasInformation"
                                                    class="margin-left-10"
                                                    style="cursor: pointer"
                                                    [tooltip]="costItemInfoTooltipTemplate"
                                                    placement="bottom"
                                                    container="body"
                                                    triggers="outsideClick"
                                                    containerClass="cost-item-info"
                                                    ><i class="text-primary text-large fa fa-info-circle"></i
                                                ></span>
                                                <div class="input-group input-group-sm" *ngIf="editing">
                                                    <ng-template #costItemTemplate let-model="item" let-index="index" let-query="query">
                                                        <div>
                                                            <span class="type-description">
                                                                <span [hidden]="!model.isRecipe"><i class="ti-layers-alt"></i></span>
                                                                <span>{{ model.itemCode ? model.itemCode + ' - ' : '' }}</span>
                                                                <span>{{ model.description }}</span>
                                                            </span>
                                                            <span [hidden]="!model.logo"><img src="{{ model.logo }}" /></span>
                                                            <span class="small">{{ model.unitCost | bxCurrency }}</span>
                                                            <span class="small">{{ model.uOM }}</span>
                                                            (<span class="small">{{ model.priceListDescription }}</span> &gt;
                                                            <span class="small">{{ model.costItemCategory }}</span> &gt;
                                                            <span class="small">{{ model.costItemSubCategory }}</span
                                                            >)
                                                        </div>
                                                    </ng-template>
                                                    <input
                                                        legacy-css
                                                        required
                                                        type="text"
                                                        id="{{ item.ID_PurchaseOrderItem }}"
                                                        [typeahead]="costItemSuggestions$"
                                                        [typeaheadAsync]="true"
                                                        (typeaheadOnSelect)="setCostItem(item, $event)"
                                                        [typeaheadItemTemplate]="costItemTemplate"
                                                        typeaheadOptionField="description"
                                                        [typeaheadIsFirstItemActive]="false"
                                                        container="body"
                                                        [typeaheadMinLength]="3"
                                                        [(ngModel)]="item.Description"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        (ngModelChange)="setupCostItems($event)"
                                                        [adaptivePosition]="true"
                                                        class="form-control"
                                                        appNullReplace="New Item"
                                                        appSelectAllOnFocus
                                                        appSelectAllOnFocusFilter="New Item"
                                                        [typeaheadWaitMs]="500"
                                                        maxlength="255" />
                                                    <span class="input-group-btn">
                                                        <button
                                                            *ngIf="item.CostItem?.HasInformation"
                                                            class="btn btn-default btn-cost-item-info"
                                                            type="button"
                                                            [tooltip]="costItemInfoTooltipTemplate"
                                                            placement="bottom"
                                                            container="body"
                                                            triggers="outsideClick"
                                                            containerClass="cost-item-info">
                                                            <i class="text-primary text-large fa fa-info-circle"></i>
                                                        </button>
                                                        <button type="button" class="btn btn-default" (click)="showCostItemsModal(item)">
                                                            <i class="fa fa-search"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                            </td>
                                            <td class="condensed-col">
                                                <app-catalogue-item-link-tile
                                                    [item]="item"
                                                    *ngIf="item.CostItem?.PriceList?.ShortCode"
                                                    [excludeRecipes]="true"
                                                    (costItemChanged)="setCostItem(item, $event)"
                                                    [tileColour]="item.CostItem.PriceList.Colour">
                                                </app-catalogue-item-link-tile>

                                                <app-ui-item-code-pill
                                                    [itemState]="item"
                                                    *ngIf="!item.CostItem && item.ItemCode"
                                                    [actionsEnabled]="true"
                                                    (itemCodeCleared)="clearItemCode(item)">
                                                </app-ui-item-code-pill>
                                            </td>
                                            <td class="condensed-col">
                                                <span *ngIf="!editing">{{ item.Notes }}</span>
                                                <input
                                                    legacy-css
                                                    type="text"
                                                    *ngIf="editing"
                                                    class="form-control input-sm"
                                                    [(ngModel)]="item.Notes"
                                                    [ngModelOptions]="{ standalone: true }" />
                                            </td>
                                            <td
                                                class="condensed-col text-left"
                                                style="min-width: 86px; width: 86px"
                                                *ngIf="purchaseOrder.Job?.CalculationMethod! >= 1">
                                                <span *ngIf="!editing">{{ taxService.costItemTypeToDisplay(item.CostItemType) }}</span>
                                                <select
                                                    legacy-css
                                                    *ngIf="editing"
                                                    class="form-control"
                                                    [(ngModel)]="item.CostItemType"
                                                    [ngModelOptions]="{ standalone: true }">
                                                    <option *ngFor="let c of taxService.allCostItemTypePairs()" [ngValue]="c.cit">
                                                        {{ c.display }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td class="condensed-col text-right min-width-150 width-150">
                                                <span *ngIf="!editing">{{ item.Quantity | imperial: item.IsImperial }}</span>
                                                <div class="input-group input-group-sm" *ngIf="editing">
                                                    <input
                                                        legacy-css
                                                        appNumeric
                                                        [decimals]="3"
                                                        class="form-control padding-5 text-right"
                                                        [imperial]="item.IsImperial"
                                                        [(ngModel)]="item.Quantity"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        appNullReplace="0"
                                                        appSelectAllOnFocus
                                                        [min]="-9999999" />
                                                    <span class="input-group-btn">
                                                        <button
                                                            id="btn-calculator"
                                                            type="button"
                                                            class="btn btn-default"
                                                            (click)="showCalculator(item)"
                                                            tooltip="Calculator">
                                                            <span
                                                                class="badge badge-info wastage-badge"
                                                                *ngIf="item.HasWastage"
                                                                tooltip="Wastage has been added to this item"
                                                                container="body"
                                                                >w</span
                                                            >
                                                            <i class="fa fa-calculator"></i>
                                                        </button>
                                                        <button
                                                            id="btn-take-offs"
                                                            type="button"
                                                            class="btn btn-default btn-default--is-narrow"
                                                            *ngIf="isTakeOffAvailable"
                                                            (click)="doTakeOff(item)"
                                                            tooltip="Takeoff Tool">
                                                            <i class="ti-ruler-alt-2"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                            </td>
                                            <td class="condensed-col text-right min-width-80 width-80">
                                                <span *ngIf="!editing">{{ item.UnitCost | bxCurrency }}</span>
                                                <input
                                                    legacy-css
                                                    id="data-unit-cost-{{ i }}"
                                                    name="data-unit-cost-{{ i }}"
                                                    type="text"
                                                    *ngIf="editing"
                                                    class="form-control text-right"
                                                    autocomplete="off"
                                                    [ngModel]="item.UnitCost"
                                                    (ngModelChange)="unitCostChanged($event, item)"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    appCurrency
                                                    appSelectAllOnFocus />
                                            </td>
                                            <td class="condensed-col text-center min-width-30 width-30">
                                                <span *ngIf="!editing">{{ item.UOM }}</span>
                                                <input
                                                    legacy-css
                                                    type="text"
                                                    *ngIf="editing"
                                                    maxlength="50"
                                                    [(ngModel)]="item.UOM"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    [typeahead]="unitMeasures"
                                                    typeaheadOptionField="Description"
                                                    class="form-control"
                                                    [typeaheadMinLength]="1"
                                                    container="body" />
                                            </td>
                                            <td class="condensed-col text-right min-width-80 width-80">
                                                {{ item.TotalCost | bxCurrency }}
                                            </td>
                                            <td
                                                class="condensed-col text-center width-80"
                                                *ngIf="purchaseOrder.Job?.CalculationMethod! >= 1">
                                                <tax-rate-selector
                                                    *ngIf="!purchaseOrder.IsTaxFree"
                                                    [editable]="editing"
                                                    [taxType]="1"
                                                    [costItemType]="item.CostItemType"
                                                    [selectedTaxCodes]="item.TaxRates"
                                                    [taxRatesParent]="purchaseOrder"
                                                    (selectedChanged)="taxRatesChanged($event, item)"
                                                    [displayAllApplicableCodes]="
                                                        purchaseOrder.AccSyncData !== 'Imported' && item.AccSyncData !== 'Imported'
                                                    "
                                                    [placement]="'left'"></tax-rate-selector>
                                            </td>
                                            <td class="condensed-col text-center min-width-60 width-60">
                                                <span *ngIf="!editing || item.ID_EstimateItem">{{ item.ParentTask }}</span>
                                                <div class="typeahead-right-align" [class.validation-warning-solid]="!item.ParentTask">
                                                    <input
                                                        legacy-css
                                                        type="text"
                                                        *ngIf="editing && !item.ID_EstimateItem"
                                                        maxlength="300"
                                                        [(ngModel)]="item.ParentTask"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        [typeahead]="parentTasks"
                                                        typeaheadOptionField="Description"
                                                        class="form-control"
                                                        container="body"
                                                        [typeaheadMinLength]="0"
                                                        typeaheadOnSelect="setParentTaskId(item, $item)"
                                                        (change)="setParentTaskIdOnChange(item)" />
                                                </div>
                                            </td>
                                            <td class="condensed-col text-right min-width-60 width 60">
                                                <a
                                                    *ngIf="editing || (item.AccSyncData === 'Imported' && !!this.importSettings)"
                                                    (click)="deleteOrder(item)"
                                                    class="btn btn-xs btn-danger"
                                                    tooltip="Delete item"
                                                    container="body"
                                                    ><i class="ti-trash"></i
                                                ></a>
                                            </td>
                                        </tr>
                                        <tr *ngIf="item._invoiceItems?.length">
                                            <td></td>
                                            <td colspan="7">
                                                <table>
                                                    <tr *ngFor="let invoiceItem of item._invoiceItems">
                                                        <td>
                                                            <a (click)="editOrderInvoice(invoiceItem.PurchaseOrderInvoice)"
                                                                >{{ invoiceItem.PurchaseOrderInvoice.InvoiceDate | date: 'fullDate' }} -
                                                                {{ invoiceItem.PurchaseOrderInvoice.Reference }}</a
                                                            >
                                                        </td>
                                                        <td class="text-right">
                                                            <span class="margin-left-10">{{
                                                                invoiceItem.Quantity | imperial: item.IsImperial
                                                            }}</span>
                                                        </td>
                                                        <td><span class="margin-left-10">&#64;</span></td>
                                                        <td class="text-right">
                                                            <span class="margin-left-10">{{ invoiceItem.UnitCost | bxCurrency }}</span>
                                                        </td>
                                                        <td><span class="margin-left-10">=</span></td>
                                                        <td class="text-right">
                                                            <span class="margin-left-10">{{ invoiceItem.TotalCost | bxCurrency }}</span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>

                        <div class="row">
                            <div class="col-md-6 col-xs-12">
                                <div class="row">
                                    <div style="width: fit-content">
                                        <div class="checkbox">
                                            <input
                                                legacy-css
                                                type="checkbox"
                                                id="isCostShownOnPrint"
                                                name="isCostShownOnPrint"
                                                [(ngModel)]="purchaseOrder.IsCostShownOnPrint" />
                                            <label for="isCostShownOnPrint" class="text-left"> Show costs when printing </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row"></div>
                                <div class="row" *ngIf="purchaseOrder.Job?.CalculationMethod! === 0">
                                    <div class="col-xs-12">
                                        <div class="checkbox">
                                            <input
                                                legacy-css
                                                type="checkbox"
                                                id="isTaxFree"
                                                name="isTaxFree"
                                                [(ngModel)]="purchaseOrder.IsTaxFree"
                                                [disabled]="purchaseOrder.OrderStatus !== 'Unsent'" />
                                            <label for="isTaxFree" class="text-left"> This order is {{ taxCode }} free </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-xs-12">
                                <div class="row">
                                    <div class="col-xs-6 text-right">
                                        <span class="text-large--purchase-order">Sub Total</span>
                                    </div>
                                    <div class="col-xs-6 text-right">
                                        <span id="orderSubTotal" class="text-large--purchase-order">{{
                                            purchaseOrder.OrderTotalExTax | bxCurrency
                                        }}</span>
                                    </div>
                                </div>
                                <div
                                    class="row margin-top-5"
                                    *ngIf="
                                        purchaseOrder.OrderType !== 'work' &&
                                        !purchaseOrder.IsPickup &&
                                        purchaseOrder.AccSyncData !== 'Imported'
                                    ">
                                    <div
                                        class="col-xs-6 text-right"
                                        style="margin-top: 4px"
                                        *ngIf="purchaseOrder.Job?.CalculationMethod! >= 1">
                                        <span class="text-large--purchase-order">Delivery/Freight</span>

                                        <tax-rate-selector
                                            style="margin-left: 4px"
                                            *ngIf="!purchaseOrder.IsTaxFree"
                                            id="delivery-cost"
                                            [editable]="purchaseOrder.OrderStatus === 'Unsent'"
                                            [taxType]="1"
                                            [costItemType]="1"
                                            [selectedTaxCodes]="purchaseOrder.DeliveryTaxRates"
                                            [taxRatesParent]="purchaseOrder"
                                            (selectedChanged)="deliveryRatesChanged($event)"
                                            [placement]="'left'"></tax-rate-selector>
                                    </div>
                                    <div
                                        class="col-xs-6 text-right"
                                        style="margin-top: 10px"
                                        *ngIf="purchaseOrder.Job?.CalculationMethod! === 0">
                                        <span class="text-large--purchase-order">Delivery/Freight</span>
                                    </div>
                                    <div class="col-xs-6">
                                        <input
                                            legacy-css
                                            type="text"
                                            [min]="0"
                                            [readonly]="purchaseOrder.OrderStatus !== 'Unsent'"
                                            class="form-control text-right"
                                            id="deliveryCost"
                                            name="deliveryCost"
                                            [ngModel]="purchaseOrder.DeliveryCost"
                                            (ngModelChange)="updateDeliverCost($event)"
                                            appCurrency
                                            autocomplete="off"
                                            appSelectAllOnFocus
                                            [selectionTimeout]="0"
                                            tooltip="Delivery cost will be spread evenly over item actuals in costings"
                                            container="body" />
                                    </div>
                                </div>
                                <div class="row margin-top-5">
                                    <div class="col-xs-6 form-inline text-right">
                                        <span class="text-large--purchase-order">{{ taxCode }}</span>
                                    </div>
                                    <div class="col-xs-6 text-right">
                                        <span id="orderTaxTotal" class="text-large--purchase-order">{{
                                            purchaseOrder.OrderTax | bxCurrency
                                        }}</span>
                                    </div>
                                </div>
                                <div class="row margin-top-5">
                                    <div class="col-xs-6 text-right">
                                        <span class="text-large--purchase-order">{{
                                            purchaseOrder.IsTaxFree ? 'Order Total' : 'Order Total (Inc)'
                                        }}</span>
                                    </div>
                                    <div class="col-xs-6 text-right">
                                        <span class="text-large--purchase-order"
                                            ><strong id="orderTotalFooter">{{ purchaseOrder.OrderTotalIncTax | bxCurrency }}</strong></span
                                        >
                                    </div>
                                </div>
                                <div class="row margin-top-5" *ngIf="purchaseOrder.OrderType !== 'work' && expenseAccounts.length">
                                    <div class="col-xs-6 text-right margin-top-10">
                                        <span class="text-large--purchase-order">Account</span>
                                    </div>
                                    <div class="col-xs-6">
                                        <select
                                            legacy-css
                                            class="form-control"
                                            id="accountCode"
                                            name="accountCode"
                                            [(ngModel)]="purchaseOrder.AccountCode"
                                            [disabled]="purchaseOrder.AccSyncData">
                                            <option value="">Please select</option>
                                            <option *ngFor="let a of expenseAccounts" [ngValue]="a.code">
                                                {{ a.fullname }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>

            <fieldset
                class="panel panel-white margin-top-10 padding-0"
                *ngIf="!!importSettings || (purchaseOrder.OrderStatus !== 'Unsent' && purchaseOrder.OrderType === 'purchase')"
                [disabled]="purchaseOrder.OrderStatus === 'Cancelled'">
                <div class="panel-heading border-light">
                    <h4 class="panel-title">Invoices/Receipts</h4>
                    <ul class="panel-heading-tabs border-light">
                        <li>
                            <div class="btn-group">
                                <button
                                    type="button"
                                    class="btn-bx-primary"
                                    *ngIf="isAllowedToReceipt && purchaseOrder.OrderStatus !== 'Received'"
                                    (click)="addOrderInvoice()"
                                    tooltip="Add invoice/receipt"
                                    container="body">
                                    <i class="ti-plus"></i>
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="panel-body">
                    <table
                        class="table table-responsive table-white"
                        *ngIf="purchaseOrder.HasInvoices"
                        [class.modal-white--disabled]="orderFormDisabled">
                        <tbody>
                            <ng-container
                                *ngFor="
                                    let invoice of purchaseOrder.PurchaseOrderInvoices
                                        | simpleFilter: { IsDeleted: false }
                                        | simpleSort: 'InvoiceDate'
                                ">
                                <tr>
                                    <td><i class="ti-receipt"></i></td>
                                    <td>
                                        <a (click)="editOrderInvoice(invoice)">
                                            <span class="text-normal">{{ invoice.InvoiceDate | date: 'fullDate' }}</span>
                                            <i
                                                *ngIf="invoice.AccSyncData && invoice.AccSyncData !== 'blocked'"
                                                class="ti-cloud-up"
                                                [tooltip]="invoice.SyncTooltip"
                                                container="body"></i>
                                        </a>
                                        <span class="block">{{ invoice.InvoiceType }}: {{ invoice.Reference }}</span>
                                        <span class="text-small">{{ invoice.Note }}</span>
                                    </td>
                                    <td class="text-right">
                                        <span class="text-large" *ngIf="!purchaseOrder.IsTaxFree">{{
                                            invoice.TotalIncTax | bxCurrency
                                        }}</span>
                                        <span class="text-large" *ngIf="purchaseOrder.IsTaxFree">{{ invoice.Total | bxCurrency }}</span>
                                    </td>
                                    <td data-title="''" class="text-right width-100 min-width-100">
                                        <button
                                            type="button"
                                            class="btn btn-xs btn-default margin-left-10"
                                            (click)="editOrderInvoice(invoice)"
                                            *ngIf="purchaseOrder.OrderStatus !== 'Received'"
                                            tooltip="Edit"
                                            container="body">
                                            <i class="ti-pencil"></i>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-xs btn-danger margin-left-10"
                                            (click)="deleteOrderInvoice($event, invoice)"
                                            *ngIf="purchaseOrder.OrderStatus !== 'Received'"
                                            tooltip="Delete"
                                            container="body">
                                            <i class="ti-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                    <div class="row" [class.modal-white--disabled]="orderFormDisabled">
                        <div *ngIf="purchaseOrder.HasInvoices" class="col-md-6 col-xs-12">
                            <div class="row">
                                <div class="col-xs-6">
                                    <span class="text-large">Invoice/Receipt Total (Inc)</span>
                                </div>
                                <div class="col-xs-6 text-right">
                                    <span class="text-large">{{ purchaseOrder.InvoiceTotalIncTax | bxCurrency }}</span>
                                </div>
                            </div>
                            <div class="row margin-top-5">
                                <div class="col-xs-6">
                                    <span class="text-large">Difference (Inc)</span>
                                </div>
                                <div class="col-xs-6 text-right">
                                    <span class="text-large"
                                        ><strong>{{ purchaseOrder.BalanceTotalIncTax | bxCurrency }}</strong></span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12 text-center" *ngIf="!purchaseOrder.HasInvoices && purchaseOrder.OrderStatus !== 'Received'">
                        <h3 class="margin-top-10 margin-bottom-10">
                            Click the plus button above to receive goods/invoices against this {{ type.value }} order.
                        </h3>
                        <button type="button" class="btn-bx-primary" [disabled]="!isAllowedToReceipt" (click)="addOrderInvoice()">
                            <i class="ti-check"></i>
                            Order Received in full
                        </button>
                    </div>

                    <div class="col-xs-12 text-center" *ngIf="purchaseOrder.HasInvoices && purchaseOrder.OrderStatus !== 'Received'">
                        <h3 class="margin-top-10 margin-bottom-10">If all required items have been received, click the button below.</h3>
                        <button type="button" class="btn-bx-primary" [disabled]="!isAllowedToReceipt" (click)="changeStatus('Received')">
                            <i class="ti-check"></i>
                            Mark Order as Received
                        </button>
                    </div>

                    <div class="col-xs-12 text-center" *ngIf="purchaseOrder.HasInvoices && purchaseOrder.OrderStatus === 'Received'">
                        <h3 class="margin-top-10 margin-bottom-10">
                            If you need to make changes to invoices/receipts, or add new ones, click the button below.
                        </h3>
                        <button type="button" class="btn btn-info" [disabled]="!isAllowedToReceipt" (click)="changeStatus('PartReceived')">
                            Change Order to Part Received
                        </button>
                    </div>
                </div>
            </fieldset>
        </fieldset>

        <div *ngIf="permissions.canViewDocuments">
            <div class="alert alert-block alert-info" *ngIf="importSettings?.copyAttachmentsOnCreate">
                <p class="text-normal">Attachments from the Accounting Provider will be copied after creation.</p>
            </div>
            <app-bx-documents
                [leadId]="documentsParams.leadId"
                [reference]="documentsParams.reference"
                [references]="documentsParams.references"
                [hideAddDescriptionButton]="true"
                [sourceType]="documentsParams.sourceType"
                [hideAddButton]="!permissions.canAddDocuments"
                [hideTrashIcon]="!permissions.canDeleteDocuments">
            </app-bx-documents>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn-bx-secondary-stroked" (click)="cancel()">
            {{ !isAllowedToSave || purchaseOrder.ID_JobPayment ? 'Close' : 'Cancel' }}
        </button>
        <button
            type="button"
            class="btn-bx-secondary ml-2"
            id="saveAndClose"
            (click)="ok()"
            *ngIf="!purchaseOrder.ID_JobPayment"
            [disabled]="saveAndCloseDisabled(editJobPurchaseOrderForm)">
            Save &amp; Close
        </button>
        <button
            type="button"
            class="btn-bx-primary ml-2"
            id="saveAndSend"
            (click)="ok(true)"
            *ngIf="!purchaseOrder.ID_JobPayment"
            [disabled]="saveAndSendDisabled(editJobPurchaseOrderForm)">
            Save &amp; Send
        </button>
    </div>
</form>
